import Page from 'classes/Page'

export default class Cart extends Page {
    constructor () {
        super({
            id: 'page-cart',
            element: '.page-cart',
            elements: {
                header: document.querySelector('.header'),
            }
        })
        if (document.getElementsByClassName(this.id).length > 0) {
            this.render();
        }
    }
    render() {
        // runs after cart update
        jQuery( document.body ).on('updated_cart_totals', ()=> {/** ignore */}, ()=> {
            this.renderCustomQtyInput();
            this.createInteractions();
        });

        this.renderCustomQtyInput();
        this.createInteractions();
    }

    removeQtyListenner = (element) => {
        var target = element.target;
        var qtyElement = this.getQtyInput(target);

        if( qtyElement.value <= 0 ) return;
        this.setQty(Number(qtyElement.value) - 1, qtyElement, target);

    }

    addQtyListenner = (element) => {
        var target = element.target;
        var qtyElement = this.getQtyInput(target);
        this.setQty(Number(qtyElement.value) + 1, qtyElement, target);
    }

    setQty(qty, qtyElement, target) {
        qtyElement.value = qty;
        target.parentElement.querySelector(".currentQty").innerHTML = qty;
        document.getElementsByName("update_cart")[0].disabled = false;
    }

    getQtyInput(element) {
        return document.getElementById(element.parentElement.getAttribute("inputId"));
    }

    createInteractions() {
        var removeQty = document.getElementsByClassName("removeQty");

        for( var i = 0; i < removeQty.length; i++ ) {
            removeQty[i].addEventListener('click', this.removeQtyListenner);
        }

        var addQty = document.getElementsByClassName("addQty");

        for( var i = 0; i < addQty.length; i++ ) {
            addQty[i].addEventListener('click', this.addQtyListenner);
        }
    }

    renderCustomQtyInput() {
        var qtyDiv = document.getElementsByClassName("quantity");

        for( var i = 0; i < qtyDiv.length; i++) {
            var qtyInput = qtyDiv[i].querySelector("input[type=\"number\"]");
            qtyInput.type="hidden";
            qtyDiv[i].innerHTML += `
                <div style="user-select:none" class="customQty" inputId="${qtyInput.id}">
                    <span style="cursor: pointer" class="removeQty">-</span>
                    <span class="currentQty"> ${qtyInput.value} </span>
                    <span style="cursor: pointer" class="addQty">+</span>
                </div>
            `;
        }
    }
}
